import { render } from "./MainCongTyHU.vue?vue&type=template&id=fdf439da&scoped=true"
import script from "./MainCongTyHU.vue?vue&type=script&lang=js"
export * from "./MainCongTyHU.vue?vue&type=script&lang=js"

import "./MainCongTyHU.vue?vue&type=style&index=0&id=fdf439da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf439da"]])

export default __exports__